import app from 'flarum/forum/app';
app.initializers.add('val-ui-unread-tag-links', () => {
  let unreadTagIds = null;
  let unreadPromise = null;
  let scheduled = false;
  function tagId(tag) {
    return tag && typeof tag.id === 'function' ? String(tag.id()) : '';
  }
  function tagParent(tag) {
    try {
      return tag && typeof tag.parent === 'function' ? tag.parent() : null;
    } catch (_) {
      return null;
    }
  }
  function descendants(tag) {
    if (!tag || !app.store || typeof app.store.all !== 'function') {
      return [];
    }
    const all = app.store.all('tags');
    const result = [];
    const queue = [tag];
    const seen = new Set();
    while (queue.length) {
      const current = queue.shift();
      const id = tagId(current);
      if (!id || seen.has(id)) continue;
      seen.add(id);
      result.push(current);
      all.forEach(candidate => {
        const parent = tagParent(candidate);
        if (parent && tagId(parent) === id) {
          queue.push(candidate);
        }
      });
    }
    return result;
  }
  function loadUnreadTagIds() {
    if (unreadTagIds) {
      return Promise.resolve(unreadTagIds);
    }
    if (unreadPromise) {
      return unreadPromise;
    }
    unreadPromise = app.request({
      method: 'GET',
      url: `${app.forum.attribute('apiUrl')}/val/ui/unread-tag-ids`
    }).then(result => {
      unreadTagIds = new Set((result && Array.isArray(result.tag_ids) ? result.tag_ids : []).map(id => String(id)));
      return unreadTagIds;
    }).catch(() => {
      unreadTagIds = new Set();
      return unreadTagIds;
    }).finally(() => {
      unreadPromise = null;
    });
    return unreadPromise;
  }
  function tagFromTile(tile) {
    const link = tile.querySelector('.TagTile-info[href]');
    if (!link) return null;
    let value;
    try {
      const path = new URL(link.href, window.location.origin).pathname;
      const match = path.match(/\/t\/([^/]+)/);
      if (!match) return null;
      value = decodeURIComponent(match[1]);
    } catch (_) {
      return null;
    }
    return app.store.all('tags').find(tag => {
      const id = tagId(tag);
      const slug = typeof tag.slug === 'function' ? String(tag.slug()) : '';
      return id === value || slug === value;
    }) || null;
  }
  function ensureMarkAllReadButton() {
    const tiles = document.querySelector('.TagsPage .TagTiles');
    if (!tiles || !app.session.user) return;
    const parent = tiles.parentElement;
    if (!parent || parent.querySelector('.val-mark-all-read-wrap')) {
      return;
    }
    const wrap = document.createElement('div');
    wrap.className = 'val-mark-all-read-wrap';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'Button val-mark-all-read';
    button.title = 'Tout marquer comme lu';
    button.setAttribute('aria-label', 'Tout marquer comme lu');
    button.innerHTML = '<i class="icon fas fa-check-double" aria-hidden="true"></i><span>Tout marquer comme lu</span>';
    button.addEventListener('click', async () => {
      if (!window.confirm('Marquer toutes les discussions comme lues ?')) {
        return;
      }
      button.disabled = true;
      try {
        await app.session.user.save({
          markedAllAsReadAt: new Date()
        });
        unreadTagIds = new Set();
        document.querySelectorAll('.val-tag-tile-unread, .val-tag-child-unread').forEach(element => {
          element.classList.remove('val-tag-tile-unread', 'val-tag-child-unread');
        });
      } finally {
        button.disabled = false;
      }
    });
    wrap.appendChild(button);
    parent.insertBefore(wrap, tiles);
  }
  function apply() {
    ensureMarkAllReadButton();
    const tiles = Array.from(document.querySelectorAll('.TagsPage .TagTile'));
    if (!tiles.length || !app.session.user) {
      return;
    }
    loadUnreadTagIds().then(ids => {
      tiles.forEach(tile => {
        if (!tile.isConnected) return;
        const tag = tagFromTile(tile);
        if (!tag) return;
        const hasUnread = descendants(tag).some(item => ids.has(tagId(item)));
        tile.classList.toggle('val-tag-tile-unread', hasUnread);
        const info = tile.querySelector('.TagTile-info');
        let mainIcon = tile.querySelector('.val-unread-icon-main');
        if (hasUnread && info) {
          if (!mainIcon) {
            mainIcon = document.createElement('i');
            mainIcon.className = 'icon fas fa-comment-dots val-unread-icon-main';
            mainIcon.title = 'Nouveaux messages';
            mainIcon.setAttribute('aria-label', 'Nouveaux messages');
          }
          info.appendChild(mainIcon);
          const name = tile.querySelector('.TagTile-name');
          if (name) {
            const infoRect = info.getBoundingClientRect();
            const nameRect = name.getBoundingClientRect();
            mainIcon.style.left = `${nameRect.left - infoRect.left - 4}px`;
            mainIcon.style.top = `${nameRect.top - infoRect.top + 1}px`;
          }
        } else if (!hasUnread && mainIcon) {
          mainIcon.remove();
        }
        tile.querySelectorAll('.TagTile-children a[href]').forEach(link => {
          let childTag = null;
          try {
            const path = new URL(link.href, window.location.origin).pathname;
            const match = path.match(/\/t\/([^/]+)/);
            if (match) {
              const value = decodeURIComponent(match[1]);
              childTag = app.store.all('tags').find(candidate => {
                const id = tagId(candidate);
                const slug = typeof candidate.slug === 'function' ? String(candidate.slug()) : '';
                return id === value || slug === value;
              }) || null;
            }
          } catch (_) {}
          const childHasUnread = childTag ? descendants(childTag).some(item => ids.has(tagId(item))) : false;
          link.classList.toggle('val-tag-child-unread', childHasUnread);
          let childIcon = link.querySelector('.val-unread-icon-child');
          if (childHasUnread) {
            if (!childIcon) {
              childIcon = document.createElement('i');
              childIcon.className = 'icon fas fa-comment-dots val-unread-icon-child';
              childIcon.title = 'Nouveaux messages';
              childIcon.setAttribute('aria-label', 'Nouveaux messages');
            }
            link.insertBefore(childIcon, link.firstChild);
          } else if (childIcon) {
            childIcon.remove();
          }
        });
      });
    });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(() => {
      scheduled = false;
      apply();
    }, 0);
  }
  const oldStyle = document.getElementById('val-unread-tag-links-style');
  if (oldStyle) {
    oldStyle.remove();
  }
  const style = document.createElement('style');
  style.id = 'val-unread-tag-links-style';
  style.textContent = `
        .TagsPage .val-mark-all-read-wrap {
            display: flex;
            justify-content: flex-end;
            margin: 0 0 12px;
        }

        .TagsPage .val-mark-all-read .icon {
            margin-right: 6px;
        }

        @media (max-width: 767px) {
            .TagsPage .val-mark-all-read span {
                display: none;
            }

            .TagsPage .val-mark-all-read .icon {
                margin-right: 0;
            }
        }

        .TagsPage .TagTile-info {
            position: relative;
        }

        .TagsPage .val-unread-icon-main {
            position: absolute;
            margin: 0;
            font-size: 1em;
            opacity: 1;
            z-index: 5;
            pointer-events: none;
        }

        .TagsPage .TagTile-children a {
            position: relative;
        }

        .TagsPage .val-unread-icon-child {
            position: absolute;
            left: -3px;
            top: 50%;
            transform: translateY(-50%);
            margin: 0;
            font-size: 0.8em;
            opacity: 1;
            z-index: 5;
            pointer-events: none;
        }

        html[data-theme] .TagsPage .TagTile-info .val-unread-icon-main,
        html[data-theme] .TagsPage .TagTile-info .val-unread-icon-child {
            color: #d9534f !important;
        }
    `;
  document.head.appendChild(style);
  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true
  });
  schedule();
});